/**
 * Resolve the hosting surface's `.doc-editor-toolbar-slot` so editor controls
 * (e.g. "Uncheck all") can portal into the chrome instead of the document body.
 * Falls back to null when no slot exists (inline toolbar).
 */

import { useLayoutEffect, useState } from 'react';

export function useToolbarSlot(editorRootRef) {
  const [toolbarSlot, setToolbarSlot] = useState(null);

  useLayoutEffect(() => {
    const root = editorRootRef.current;
    const surface = root?.closest(
      '.doc-fullpage, .mfv-doc-sheet-page, .doc-sheet, .library-doc-pane'
    );
    setToolbarSlot(
      surface?.closest('.doc-sheet')?.querySelector('.doc-editor-toolbar-slot') ||
        surface?.querySelector('.doc-editor-toolbar-slot') ||
        null
    );
  }, [editorRootRef]);

  return toolbarSlot;
}
